<template>
  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">
        <div class="col-lg-4 text-center text-lg-start alignFix posRel">
          <div class="assistant">
            <div class="row assHead g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRav1.png"></div>
              <div class="col-8 txt"> Ilaria <div>✈ Servizio Clienti Rimborso al Volo</div>
              </div>
            </div>
            <div class="row assContent g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRimborsoalVolo.jpg"></div>
              <div class="col-10 txt">😀Ed eccoci arrivati all'ultimo passaggio. Qui riportiamo il riepilogo delle tue informazioni. Verifica che siano tutte corrette. Nel caso non ricordassi le motivazioni espresse dalla compagnia aerea, prova a dare uno sguardo alle email 🔎. </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 bgWight formStyle posRel">
          <div class="headForm">
            <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.svg">
          </div>
          <div class="p-4 p-md-4 riepilogoForm">
            <fieldset disabled>
              <div class="row g-2">
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Nome</label>
                    <input type="text" id="nome" class="form-control" v-bind:placeholder="nome">
                  </div>
                </div>
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Cognome</label>
                    <input type="text" id="cognome" class="form-control" v-bind:placeholder="cognome">
                  </div>
                </div>
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Email</label>
                    <input type="email" id="email" class="form-control" v-bind:placeholder="email">
                  </div>
                </div>
              </div>
              <div class="row g-2">
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Tel/Cell</label>
                    <input type="text" id="tel" class="form-control" v-bind:placeholder="telefono">
                  </div>
                </div>
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Compagnia</label>
                    <input type="text" id="compagnia" class="form-control" v-bind:placeholder="compagnia.nome">
                  </div>
                </div>
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">N° volo</label>
                    <input type="text" id="volo" class="form-control" v-bind:placeholder="numerovolo">
                  </div>
                </div>
              </div>
              <div class="row g-2">
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Partenza</label>
                    <input type="text" id="partenza" class="form-control" v-bind:placeholder="partenza.text">
                  </div>
                </div>
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Destinazione</label>
                    <input type="text" id="destinazione" class="form-control" v-bind:placeholder="destinazione.text">
                  </div>
                </div>
                <div class="form-floating mb-1 col-md-4 fixLabel">
                  <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Data volo</label>
                    <input type="text" id="data" class="form-control" v-bind:placeholder="datavololbl" style="padding:10px 12px;">
                  </div>
                </div>
              </div>
              <div class="mb-1">
                <label for="disabledTextInput" class="form-label">Tipologia disservizio</label>
                <input type="text" id="disservizio" class="form-control" v-bind:placeholder="$t('message.problematica'+disservizio)" >
              </div>
            </fieldset>
            <div class="mb-3">
              <label for="descrizione">Descrivi nel dettaglio il problema relativo al tuo volo. Se hai avuto una cancellazione/modifica, indicaci in quale data è avvenuta. * </label>
              <textarea class="form-control placeholder-light" v-model="descrizione" placeholder="Scrivi qui... (Es. in data 01/01/2021 ho ricevuto una email dall'agenzia di viaggi, nella quale ci veniva indicata la cancellazione del volo)." id="descrizione" style="height: 100px"></textarea>

            </div>
            <div class="error" v-if="(v$.descrizione.required.$invalid ) && showerrors">Inserire una descrizione del problema riscontrato</div>
            <div class="row g-3 ">
              <div class="col-md-6 order-md-3 ">
                <span class="modificaDati modificaDatiRule" @click="modificaIDati()">&lt;&lt; Modifica i dati </span>
                <button type="submit" class="btn styleBtn mb-3 float-end" @click="submit()">Conferma ></button>
              </div>
              <div class="col-md-6 order-md-1">
                <p class="txtFooForm"></p>
              </div>

            </div>
            <div class="mb-3 informativa" style="cursor: pointer">
               <label for="privacypolicycheck" class="form-check-label" style="cursor: pointer"> <input type="checkbox" v-model="privacypolicy" id="privacypolicycheck" > Cliccando qui dichiari di aver preso visione della nostra privacy policy e autorizzi al trattamento dei tuoi dati personali secondo quanto stabilisce il nuovo Regolamento Europeo (GDPR n.679/2016) - Vedi <a href="https://www.rimborsoalvolo.it/informativa-sulla-privacy" target="_blank">Privacy Policy</a> * </label>
               <div class="error" style="font-weight: bold; font-size: 18px" v-if="!privacypolicy && showerrors">Confermare di aver preso visione della Privacy Policy</div>
            </div>

            <div class="mb-3 informativa" style="cursor: pointer">
                <label for="comunicazionicommercialicheck" class="form-check-label" style="cursor: pointer"> <input type="checkbox" v-model="comunicazionicommerciali" id="comunicazionicommercialicheck"> Cliccando qui autorizzi l’invio di comunicazioni marketing promozionali, commerciali, al tuo indirizzo e-mail, esclusivamente da parte di Rimborso al Volo</label>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
    <trust-pilot></trust-pilot>
    <conteggio-reclami></conteggio-reclami>
    <recensioni-f-b></recensioni-f-b>
    <sezione-a-p-r-a></sezione-a-p-r-a>
    <page-footer></page-footer>
</template>

<script>
import MessaggioChiusoOK from "@/components/MessaggioChiusoOK";
import useVuelidate from "@vuelidate/core";
import {useStore} from "vuex";
import {computed} from "vue";
import { confermaInserimento } from "@/lib/submit";
import moment from "moment";
import {verificaStep} from "@/lib/verificaStep";
import FakeChat from "@/components/FakeChat";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";
import PopupCodicePriorita from "@/components/PopupCodicePriorita";
import {required} from "@vuelidate/validators";
export default {
  name: "QuartoStep",
  setup() {
    const store = useStore();
    const ticketchiusiokassociati = computed(() => store.state.compilazione.ticketchiusokassociati);
    const nome = computed(() => store.state.richiedente.nome);
    const cognome = computed(() => store.state.richiedente.cognome);
    const email= computed(() => store.state.richiedente.email);
    const telefono = computed(() => store.state.richiedente.telefono);
    const compagnia = computed(() => store.state.volo.compagnia);
    const partenza = computed(() => store.state.volo.partenza);
    const destinazione = computed(() => store.state.volo.destinazione);
    const numerovolo = computed(()=>store.state.volo.numerovolo);
    const datavolo = computed(()=>store.state.volo.datavolo);
    const disservizio = computed(()=>store.state.volo.tipoproblema);
    const tokencampagna = computed( ()=>store.state.compilazione.tokencampagna);
    const utm_source = computed( ()=>store.state.compilazione.utm_source);
    const utm_medium = computed( ()=>store.state.compilazione.utm_medium);
    const utm_campaign = computed( ()=>store.state.compilazione.utm_campaign);
    const partner_code = computed( ()=>store.state.compilazione.partner_code);
    const preavviso = computed(()=>store.state.volo.preavviso);
    const recaptchatoken = computed(()=>store.state.compilazione.recaptcha_token);
    const s_completati = computed(()=>store.state.compilazione.stepcompletati);
    const s_coincidenzepresenti= computed(()=>store.state.volo.coincidenzepresenti);
    const s_datacomunicazionecompagnia = computed( ()=>store.state.volo.datacomunicazionecompagnia);
    const s_datariconsegnabagaglio = computed( ()=>store.state.volo.datariconsegnabagaglio);
    const s_datariprotezione = computed(()=>store.state.volo.datariprotezione);
    const s_step4_inviato = computed( ()=>store.state.gtmstate.step4inviato);
    return {
      ticketchiusiokassociati,
      nome,
      cognome,
      email,
      telefono,
      compagnia,
      partenza,
      destinazione,
      numerovolo,
      datavolo,
      disservizio,
      tokencampagna,
      utm_source,
      utm_medium,
      utm_campaign,
      partner_code,
      preavviso,
      recaptchatoken,
      s_completati,
      s_coincidenzepresenti,
      s_datacomunicazionecompagnia,
      s_datariconsegnabagaglio,
      s_datariprotezione,
      s_step4_inviato,
      v$: useVuelidate(),
      setTicketId: (value)=>{
        store.dispatch('compilazione/commitTicketId',value);
      },
      setStepCompletato: function(){
        store.dispatch('compilazione/commitSetStepCompletato',4);
      },
      setTicketRef: (value)=>{
        store.dispatch('compilazione/commitSetTicketref',value);
      },
      setStep4Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio4',true);
      }
    }
  },
  components:{
    MessaggioChiusoOK,
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
    FakeChat,
    PopupCodicePriorita
  },
  data(){
    return {
      showerrors : false,
      descrizione: null,
      datavololbl: moment(this.datavolo).format('DD/MM/YYYY'),
      privacypolicy : false,
      comunicazionicommerciali : false,
      submitAvviato : false,
    }
  },
  mounted() {
    let step = verificaStep([...this.s_completati]);
    if(step.step <= 3) {this.$router.push(step.url);}
    else if(step.step === 5) {this.$router.push({name:'step5'});}

    window.scrollTo(0,0);

    if(!this.s_step4_inviato) {
      this.setStep4Inviato();
      this.$gtm.trackEvent({
            event: 'step_visitato',
            value: 4,
          }
      );

      if(typeof fbq !== 'undefined') {
        fbq('track','PageView');
        fbq('trackCustom','Step4');
      }
    }
  },
  validations: {
    descrizione: {
      required
    },
  },

  methods: {
    prossimoStep(){
      this.setStepCompletato();
    },
    async submit(){
      const valid = await this.v$.$validate();
      if(this.submitAvviato) return;

      if(!valid || !this.privacypolicy){
        this.showerrors = true;
        this.submitAvviato = false;
        return;
      }else {
        this.submitAvviato = true;
      }

      let reqobj =
      {
        compagnia: this.compagnia.id,
            datavolo: moment(this.datavolo).format('YYYY-MM-DD'),
          numerovolo: this.numerovolo,
          nome: this.nome,
          cognome: this.cognome,
          email: this.email,
          telefono: this.telefono,
          disservizio: this.disservizio,
          informazioni: this.descrizione,
          recaptcha_token: this.recaptchatoken,
          partenza: this.partenza.id,
          destinazione: this.destinazione.id,
          cmptk: this.tokencampagna,
          utm_source: this.utm_source,
          utm_medium : this.utm_medium,
          utm_campaign : this.utm_campaign,
          preavviso: this.preavviso,
          //coincidenze: JSON.stringify(context.state.volo.coincidenze),
          prtncode: this.partner_code,
          coincidenzepresenti: this.s_coincidenzepresenti,
          datariconsegnabagaglio: this.s_datariconsegnabagaglio != null ? moment(this.s_datariconsegnabagaglio).format('YYYY-MM-DD') : null,
          datacomunicazionecompagnia : this.s_datacomunicazionecompagnia != null ? moment(this.s_datacomunicazionecompagnia).format('YYYY-MM-DD') : null,
          datariprotezione : this.s_datariprotezione != null ? moment(this.s_datariprotezione).format('YYYY-MM-DD') : null,
          comunicazionicommerciali: this.comunicazionicommerciali,
          locale: this.$root.$i18n.locale,
      }
      let me = this;
      confermaInserimento(reqobj).then(function(response){
        if(response.data.status === "OK") {
          me.setTicketId(response.data.ticketid);
          me.setStepCompletato(4);
          me.setTicketRef(response.data.tktref);
          me.$router.push({name:'step5'});
          me.submitAvviato = false;
        }else {
          this.$router.push({name:'error'});
          me.submitAvviato = false;
        }
      }).catch((err)=>{
        me.submitAvviato = false;
        console.log(err);
        me.$router.push({name:'error'});
      })
    },
    modificaIDati(){
      this.$router.push({name:'step1'});
    }
  }
}
</script>

<style scoped>
.placeholder-light::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ADADADFF;
  opacity: 1; /* Firefox */
}

.placeholder-light::placeholder:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #ADADADFF;
}

.placeholder-light::placeholder::-ms-input-placeholder { /* Microsoft Edge */
  color: #ADADADFF;
}


.modificaDatiRule {
  color: #425465;
  font-weight: 700;
  cursor: pointer;
}

</style>